(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dis-shipping-transparency"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-dis-shipping-form]');
    if (!form) return;

    event.preventDefault();
    const result = form.parentElement.querySelector('[data-dis-shipping-result]');
    const button = form.querySelector('button');
    const formData = new FormData(form);
    const params = new URLSearchParams();

    params.set('shipping_address[country]', formData.get('country'));
    params.set('shipping_address[zip]', formData.get('zip'));
    params.set('shipping_address[province]', formData.get('province'));
    const container = form.closest('.dis-shipping');
    result.textContent = container.dataset.calculating;
    button.disabled = true;

    try {
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const response = await fetch(`${root}cart/shipping_rates.json?${params.toString()}`, {
        headers: { Accept: 'application/json' }
      });
      const data = await response.json();

      if (!response.ok || !data.shipping_rates || data.shipping_rates.length === 0) {
        throw new Error('rates_unavailable');
      }

      const list = document.createElement('ul');
      data.shipping_rates.forEach((rate) => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        const price = document.createElement('strong');
        name.textContent = rate.name;
        price.textContent = new Intl.NumberFormat(document.documentElement.lang, {
          style: 'currency',
          currency: rate.currency
        }).format(Number(rate.price));
        item.append(name, price);
        list.append(item);
      });
      result.replaceChildren(list);
    } catch (error) {
      result.textContent = container.dataset.unavailable;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
